import React, { useEffect, useState } from 'react';
import s from './SettingPage.module.css';
import { useSelector } from 'react-redux';
import { selectIsLoading } from '../../store/selectors/authSelectors';
import Spinner from '../../shared/ui/spinner/Spinner';
import UserProfileButton from '../../shared/ui/user-profile-button/UserProfileButton';
import IconSettingProfile from '../../shared/ui/icons/IconSettingProfile';
import IconSettingSubscription from '../../shared/ui/icons/IconSettingSubscription';
import IconSettingNotification from '../../shared/ui/icons/IconSettingNotification';
import IconSettingSecurity from '../../shared/ui/icons/IconSettingSecurity';
import IconSettingSignout from '../../shared/ui/icons/IconSettingSignout';
import Profile from './component/profile/Profile';
import Subscription from './component/subscription/Subscription';
import Notification from './component/notification/Notification';
import Security from './component/security/Security';
import SignOut from './component/sign-out/SignOut';
import { toast } from 'react-toastify';

const navigationItems = [
    {
        icon: <IconSettingProfile />,
        label: 'Profile Info',
        component: <Profile />,
        disabled: false,
    },
    {
        icon: <IconSettingSubscription />,
        label: 'Subscription details',
        component: <Subscription />,
        disabled: false,
    },
    {
        icon: <IconSettingNotification />,
        label: 'Notifications',
        component: <Notification />,
        disabled: true,
    },
    {
        icon: <IconSettingSecurity />,
        label: 'Security settings',
        component: <Security />,
        disabled: true,
    },
];

const SettingPage = () => {
    const isLoading = useSelector(selectIsLoading);
    const [active, setActive] = useState(navigationItems[0]);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const checkoutStatus = params.get('checkout_status');
        const subscription = params.get('subscription');
        const tab = params.get('tab');

        if (checkoutStatus) {
            if (checkoutStatus === 'success') {
                toast.success(
                    `Subscription updated successfully to ${
                        subscription
                            ? subscription.charAt(0).toUpperCase() + subscription.slice(1)
                            : ''
                    } plan`,
                );
            } else {
                toast.error('Subscription checkout failed or was canceled.');
            }

            const subscriptionItem = navigationItems.find(
                (item) => item.label === 'Subscription details',
            );
            if (subscriptionItem) {
                setActive(subscriptionItem);
            }

            window.history.replaceState({}, document.title, window.location.pathname);
        }

        if (tab === 'subscription') {
            const subscriptionItem = navigationItems.find(
                (item) => item.label === 'Subscription details',
            );
            if (subscriptionItem) {
                setActive(subscriptionItem);
            }
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, []);

    if (isLoading) {
        return <Spinner />;
    }

    return (
        <div className={s.container}>
            <div className={s.header}>
                <h3 className={s.header_title}>Settings</h3>
                <div className={s.header_actions}>
                    <UserProfileButton />
                </div>
            </div>

            <div className={s.wrapper}>
                <div className={s.navigation_card}>
                    {navigationItems.map((item) => (
                        <button
                            key={item.label}
                            className={`${s.nav_item} ${active?.label === item?.label ? s.active : ''} ${item.disabled ? s.disabled : ''}`}
                            onClick={() => !item.disabled && setActive(item)}
                            disabled={item.disabled}
                        >
                            {item.icon} {item.label}
                        </button>
                    ))}
                    <SignOut />
                </div>

                <div className={s.content}>
                    <h4>{active.component}</h4>
                </div>
            </div>
        </div>
    );
};

export default SettingPage;
